import { building } from '$app/environment';

export function getSearchParams(url: URL, key: string, _default?: string): string {
	if (building) {
		return _default!
	}
	return url.searchParams.get(key) || _default!

}